<template>
	<div>
		<div class="by-picker" @click="visible = true">{{ showVal }}</div>
		<!--
			appendToBody：面板是 fixed 全螢幕遮罩，留在原地會被祖先的捲動容器
			（如 Dialog 限高後的 .dialog-body）連同 fixed 一起裁成容器寬度
		-->
		<VuePicker
			ref="pkr"
			class="pkr"
			:data="data"
			:defaultIndex="selectedIndex"
			appendToBody
			:visible.sync="visible"
			:title="placeholder"
			cancelText="取消"
			confirmText="確認"
			showToolbar
			maskClick
			@change="onChange"
			@cancel="onCancel"
			@confirm="onConfirm"
		/>
	</div>
</template>

<script>
import VuePicker from './fork/VuePickers'

export default {
	name: 'ByVuePicker',
	components: {
		VuePicker,
	},
	props: {
		value: String | Number | Boolean,
		placeholder: { type: String, default: '請選擇' },
		data: { type: Array, default: () => [] },
		format: { type: Function, default: null },
	},
	data() {
		return {
			visible: false,
		}
	},
	computed: {
		current() {
			const { value, data, format } = this
			if (Array.isArray(value)) {
				const els = data.map((e, i) => e.find(f => f.value === value[i]))
				return format ? format(els) : els.map(e => e.label)
			} else {
				const el = data[0]?.find(e => e.value === value)
				if (el == null) return null
				return format ? format(el) : el.label
			}
		},
		showVal() {
			return this.value ? this.current : this.placeholder
		},
		// 目前值在各欄中的索引，供內層 picker 定位；未選或值已不在最新清單中時回 0。
		// 沒有這個，picker 每次開啟都從第一項起算，使用者不滾動直接確認就會被改掉已選值。
		// 單欄回數字、多欄回陣列，與內層 defaultIndex 的型別契約一致。
		selectedIndex() {
			const { value, data } = this
			if (Array.isArray(value)) {
				return data.map((column, i) => {
					const index = column.findIndex(item => item.value === value[i])
					return index < 0 ? 0 : index
				})
			}
			const index = data[0]?.findIndex(item => item.value === value) ?? -1
			return index < 0 ? 0 : index
		},
	},
	methods: {
		onConfirm(e) {
			this.visible = false
			// 每一欄都要有有效項目才採用：多欄時若只檢查第一欄，
			// 後續欄為 null（例如該欄整欄不可選）會在 map 取值時解參考 null
			if (!Array.isArray(e) || !e.length || e.some(item => item == null)) {
				return
			}
			this.$emit('input', e.length > 1 ? e.map(f => f.value) : e[0].value)
		},
		onCancel() {
			this.visible = false
		},
		onChange(e) {
			this.$emit('change', e)
		},
		setColumn(i, column) {
			this.$refs.pkr?.setColumn(i, column)
		},
	},
}
</script>

<style lang="sass" scoped>
.by-picker
  border-radius: 50px
  background: #f3f3f3
  padding: 12px
  position: relative
  &::after
    content: ''
    position: absolute
    right: 10px
    top: calc(50% + 3px)
    transform: translateY(-50%)
    border-top: 6px solid #000
    border-bottom: 4px solid transparent
    border-left: 4px solid transparent
    border-right: 4px solid transparent
.pkr
  &::v-deep
    .header
      .left, .right
        width: auto
    .content
      .colums
        position: relative
        z-index: 1
    .hairline
      z-index: 0
      &::after
        background: #ebedf0
        border-radius: 8px
        overflow: hidden
        width: calc(200% - 40px)
        left: calc(-50% + 20px)
</style>
